import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserProfile } from "services";
import {
  clearAccessToken,
  clearRefreshToken,
  removeSessionStorage,
} from "utils";

import { initUserSessionAction, fetchingUserSessionAction } from "./thunks";

export interface AuthReducerState {
  status: "AUTH" | "UNAUTH";
  userProfile: UserProfile | null;
  userProfileInitializing: boolean;
  userProfileFetching: boolean;
}

const initialState: AuthReducerState = {
  status: "UNAUTH",
  userProfile: null,
  userProfileInitializing: false,
  userProfileFetching: false,
};

export const authSlice = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    logout: (state) => {
      clearAccessToken();
      clearRefreshToken();
      removeSessionStorage("Organization");
      state.status = "UNAUTH";
      state.userProfile = null;
      state.userProfileInitializing = false;
      state.userProfileFetching = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchingUserSessionAction.pending, (state) => {
      state.userProfileFetching = true;
    });
    builder.addCase(
      fetchingUserSessionAction.fulfilled,
      (state, action: PayloadAction<UserProfile>) => {
        state.userProfileFetching = false;
        state.status = "AUTH";
        state.userProfile = action.payload;
      }
    );
    builder.addCase(fetchingUserSessionAction.rejected, (state) => {
      state.userProfileFetching = false;
      state.status = "UNAUTH";
      state.userProfile = null;
    });
    builder.addCase(initUserSessionAction.pending, (state) => {
      state.userProfileInitializing = true;
    });
    builder.addCase(
      initUserSessionAction.fulfilled,
      (state, action: PayloadAction<UserProfile>) => {
        state.userProfileInitializing = false;
        state.status = "AUTH";
        state.userProfile = action.payload;
      }
    );
    builder.addCase(initUserSessionAction.rejected, (state) => {
      state.userProfileInitializing = false;
      state.status = "UNAUTH";
      state.userProfile = null;
    });
  },
});
